import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = {
  asc: 'desc',
  desc: '',
  '': 'asc',
};

export interface SortEvent<T = any> {
  column: keyof T | '';
  direction: SortDirection;
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'th[sortable]',
  standalone: true,
})
export class SortableHeaderDirective<T = any> {
  @Input() sortable: keyof T | '' = '';
  @Input() direction: SortDirection = '';
  @Input() disabled = false;
  @Output() sort = new EventEmitter<SortEvent>();

  @HostBinding('class.asc')
  get ascClass() {
    return this.direction === 'asc';
  }

  @HostBinding('class.desc')
  get descClass() {
    return this.direction === 'desc';
  }

  @HostListener('click')
  rotate() {
    if (this.disabled) return;
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }
}
